import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Tabs, Tab, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  displayName: "release-notes",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [{}];
    var scrollToElement = initDeepLinkData(this.props);
    return {
            data: data,
            navMenuParent: null,
            navMenu: null,
            scrollToElement: scrollToElement};
  },

  componentDidMount: function() {
    this.scrollingEl = document.getElementById("scrollingEl");
    mountCode(this);
    this.scrollToGuide = this.props.location.query.location;
    scrollingEl.scrollTop = 0;
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {
    const appToken = "Sign up to get your own Key .";
    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container updating">

              <section>
                <div className="title">
                  <Glyphicon glyph="pencil" />
                  <h2 id="keeping-zoom-updated">Keeping Up-to-Date</h2>
                </div>
                <p>Staying on the latest version of FaceTec SDKs are important and required.  Find out more about our policies in this guide.</p>
                <hr/>
              </section>

              <section>
                <h3 id="the-latest-version-of-zoom">The Latest Version of FaceTec SDKs</h3>
                <p>It is imperative that applications stay up-to-date with FaceTec SDKs.</p>
                <p>Just as Android, iOS, the Web, platform tooling, hardware capabilities, and the security landscape are constantly evolving, so to is the FaceTec SDK product.</p>
                <p>FaceTec's goal is to strike a balance between platform stability with constant improvements we are making in the areas of:</p>
                <ul>
                  <li>Security</li>
                  <li>Algorithmic Accuracy (Liveness, Matching, Quality, etc.)</li>
                  <li>Usability</li>
                  <li>Compatibility</li>
                  <li>Performance</li>
                  <li>New Features</li>
                  <li>Reliability</li>
                  <li>Developer Experience</li>
                  <li>Ease of Integration</li>
                </ul>
                <hr />
              </section>


              <section>
                <h3 id="security-as-the-primary-motivator">Security as the Primary Motivator</h3>
                <p>At FaceTec, <strong>SECURITY is the #1 priority</strong>, and our Update Policy is derived from this philosophy.</p>
                <p>FaceTec is constantly innovating in the area of security.  This includes improving and strengthening our already highly robust algorithms, but this also includes adding feature like webcam bypass detection, replay attack detection, FaceMap tamper detection, and much more.  FaceTec Partners & Customers must be ready and willing to adapt so that we can stay ahead for the fraudsters and the competition.</p>
                <hr />
              </section>


              <section>
                <h3 id="nist-and-owasp-guidance">NIST & OWASP Guidance</h3>
                <p>NIST and OWASP produce a few commonly-accepted guidance on security best practices.  <strong>Patch management and staying up-to-date with software, especially security software</strong>, is a top best practice that is highly recommended.</p>
                <p><a href="https://owasp.org/www-project-top-ten/" target="_blank">OWASP 2019 Top Ten</a> - <em>"Security misconfiguration is the most commonly seen issue... Not only must all operating systems, frameworks, libraries, and applications be securely configured, but they must be patched/upgraded in a timely fashion."</em></p>
                <p><a href="https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-40r3.pdf" target="_blank">NIST Guide to Enterprise Patch Management</a> - <em>"Patch management is the process for identifying, acquiring, installing, and verifying patches for products and systems. Patches correct security and functionality problems in software and firmware... it is still important for all organizations to carefully consider patch management in the context of security because patch management is so important to achieving and maintaining sound security. "</em></p>
              </section>

              <hr />

              <section>
                <h3 id="facetec-update-policy">FaceTec's Update Policy</h3>

                <p>All Partners, Customers, and Developers must update to the latest version of FaceTec SDKs within 90 days of release.</p>
                <p>Usage of FaceTec SDKs libraries that are older than 90 days old is not supported.</p>

                <p><strong>FaceTec Server SDK</strong> updates, in the vast majority of cases, are non-breaking.  And the latest version of FaceTec Server <strong>is always backwards compatible with FaceMaps generated using older versions of FaceTec SDKs libraries</strong>.  This means that updating FaceTec Server <strong>mostly involves simply installing the new library and you will get all of the benefits of our latest security and usability improvements</strong>.</p>

                <p><strong>FaceTec Device SDK</strong> updates are also mostly non-breaking.  We realize that there is a development cycle whereby staying "Up-to-Date" with Device SDK versions requires installing the new SDK in your App and then getting the change into the App Store, Google Play, or live on your web site.  We also realize that even after this, users must then download the latest version of your App to then get this update.  So the <strong>90 day requirement in this case describes the time from release to the Developer Site until the SDK shows up in the latest version of your SDK or App.</strong></p>

                <blockquote><p><strong>If you are using FaceTec SDKs free in Development Mode</strong>, FaceTec may at any time, and without warning, revoke Key validation if your application is using a version of FaceTec SDKs that FaceTec deems as  outdated.  If you are using FaceTec SDKs in Development Mode, please stay up-to-date with your version of FaceTec SDKs to ensure your applications continue to function while you are developing.</p></blockquote>
                <hr />
              </section>


              <section>
                <h3 id="non-negotiability">Non-negotiability</h3>
                <p>Our update policy is <strong>non-negotiable and a must-have</strong>, so you are highly encouraged to architect systems that allow you to perform FaceTec updates quickly.</p>
                <hr />
              </section>


              <section>
                <h3 id="release-notifications">Release Notifications</h3>
                <p>FaceTec sends out periodic update emails to all FaceTec Developer Account emails, but we do not send mail for each and every update. Please check the <Link to="/downloads">Download page</Link> to ensure you have the latest version!</p>
                <hr />
              </section>


              <section>
                <h3 id="updating-your-apps">Updating Your Apps</h3>
                <p>We make our best effort to ensure upgrades are easy and don't break your Apps or impact your Users.  Please check out the <Link to="/release-practices">FaceTec Release Practices</Link> guide for more information.</p>
                <hr />
              </section>


              <section>
                <h3 id="what-are-miscellaneous-bug-fixes">What are "Miscellaneous Bug Fixes"?</h3>
                <p>Sometimes, FaceTec <Link to="/release-notes">Release Notes</Link> for a given update include an unspecific note that the release contains "Miscellaneous Bug Fixes".  As a closed-source security product, FaceTec often includes improvements to the FaceTec SDK libraries that relate to features and internal functionality that we consider trade secrets, and oftentimes relate to the security or algorithmic accuracy of security-related systems inside the FaceTec SDK Engine.  Unfortunately, for these reasons, we cannot divulge each and every code change that we make to the product.</p>
                <hr />
              </section>


              <section>
                <h3 id="new-features">New Features</h3>
                <p>Added or removed APIs, new behaviors, new features, removed features, and other major functionality changes are noted in our <Link to="/release-notes">Release Notes</Link>, where possible.</p>
                <hr />
              </section>


              <section>
                <h3 id="what-version-am-i-on">What Version Am I On?</h3>
                <p>On each platform, there is a <code>.version</code> property or <code>.version()</code> function on the main <code>ZoomSDK</code> or <code>ZoomAuthentication</code> object.</p>
                <hr />
              </section>


              <section>
                <h3 id="what-is-the-current-version-of-zoom">What is the Current Version of FaceTec SDKs?</h3>
                <p>Check out our <Link to="/downloads">Download page</Link> for more information!</p>
                <hr />
              </section>


              <section>
                <h3 id="why-dont-you-have-your-releases-on-maven-cocoapods-or-other-package-managers">Why don't you have your releases on Maven, Cocoapods, or other package managers?</h3>
                <p>FaceTec requires email signup and confirmation to download the SDKs, so we can't put the SDKs on a public repository.</p>
                <p>Maven, Cocoapods, and most package managers, by design, allow developers to specify specific versions of software to use.  FaceTec requires you to use the latest version.  Thus, FaceTec hosting the SDKs even in a private repository would be counter-productive to our goals of keeping you on our latest version.</p>
              </section>
            </div>
            <SDKSidebar menuType="main" title="Keeping FaceTec Updated"/>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/updating.jsx